var map = {
	"./Destijl.svg": 925,
	"./Evatik.svg": 926,
	"./Fysh.svg": 927,
	"./Kama.svg": 928,
	"./LBDesign.svg": 929,
	"./LBDesign_white.svg": 930,
	"./Libuda-Logo.svg": 345,
	"./Libuda.svg": 931,
	"./LibudaLogo_komplett_weiß.svg": 932,
	"./LifeItalia.svg": 933,
	"./Quiksilver.svg": 934,
	"./Roxy.svg": 935,
	"./Superflex.svg": 936,
	"./SuperflexKids.svg": 937,
	"./Youpi.svg": 938,
	"./Yous.svg": 939
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 924;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*\.svg$
// module id = 924
// module chunks = 0